import { PageHeader, Card, CardHeader } from "../components/primitives";

export default function BoardReports() {
  return (
    <div>
      <PageHeader title="Board & senior management reports" subtitle="Monthly · Quarterly · Annual programme review" sections={["5.8","5.9"]} />
      <div className="p-6 grid grid-cols-3 gap-3">
        {[
          ["Monthly compliance summary","22 May 2026","CCO","PDF · 14 pages","Alerts: 340 open · STRs: 47 filed · Sanctions hits: 9 · Models: 4 green / 1 amber"],
          ["Quarterly AML risk report","30 Apr 2026","CCO + Head of AML","PDF · 38 pages","Risk distribution, model performance, validation outcomes, regulatory engagement"],
          ["Annual AML programme review","31 Mar 2026","CCO","PDF · 86 pages","Programme effectiveness, board attestation, examiner-ready package"],
          ["Thematic — Cross-border high-velocity","18 May 2026","Head of AML","PDF · 12 pages","Emerging pattern · 4 cases · ₦480M total at risk"],
          ["Thematic — PEP risk management","04 May 2026","Sanctions Officer","PDF · 18 pages","Domestic PEP coverage, family/associate framework, EDD cycle"],
          ["Thematic — Beneficial ownership","22 Apr 2026","KYC/CDD Manager","PDF · 16 pages","CAC integration, BO discrepancy detection, network analysis case studies"],
        ].map(([t, d, owner, fmt, headline], i) => (
          <Card key={i}>
            <CardHeader title={t} subtitle={`${d} · ${owner}`} />
            <div className="p-3 text-[12px]">
              <p className="text-ink-muted">{headline}</p>
              <div className="flex items-center justify-between mt-3">
                <span className="text-[11px] text-ink-subtle">{fmt}</span>
                <button className="text-amber-600 text-[12px]">Download →</button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
